<template>
  <div class="content-box">


      <el-image src="/static/imgs/logo.png" fit="cover" class="phon-logo" style="width: 15rem;margin: .8rem;" />

    <el-image src="/static/imgs/banner@1x.png" fit="cover" class="saveimg w-img" />
    <el-image src="/static/imgs/phone/p-gywm.png" fit="cover" class="p-img" />

    <div class="w-content">

      <div class="oobox">

        <div class="jianjie ">
          <img src="/static/imgs/ads.png" class="jianjie-img" />
          <div class="jianjie-div">
            <div class="tit">
              {{datms.gsnm}}
              <div class="bar"></div>
            </div>
            <div class="jianjie-tx" v-html="datms.brief">

            </div>
            <div class="jianjie-list">
              <div :class="['akl',index?'mto':'']" v-for="(item,index) in datms.gslist" :key="index">
                <img :src="item.img" class="jj-img fl" />
                <div class="fl whj">
                  <div class="tko">{{item.name}}</div>
                  <div class="tkos">{{item.txt}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="w100 mkls" style="background: #fff;">
        <div class="youshi w1200">
          <div class="w100 centers asdw">
            <div class="ytit">我们的优势</div>
            <div class="Advantage">Advantage</div>
            <div class="bars"></div>
          </div>
          <div class="box-list">
            <div class="opska" v-for="(item,index) in datms.superiority" :key="index">
              <div class="asds">
                <img :src="item.img" class="ysimg" />
              </div>
              <div class="lkoj">
                <div class="pols">{{item.name}}</div>
                <div class="polst">{{item.txt}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="jiaoyi">
        <div class="m78">
          <div v-for="(item,index) in datms.jingyan" :key="index" class="w253">
            <img :src="item.img" class="img-ico" />
            <div class="lan">{{item.txt}}</div>
            <div class="jinyan">{{item.name}}</div>
            <div class="shengeng">{{item.tyt}}</div>
          </div>
        </div>
      </div>
      <div class="bgbox">
        <div class="webdian w1200">
          <div class="w100 centers asdw">
            <div class="ytit">全国网点</div>
            <div class="Advantage">Outlets</div>
            <div class="bars"></div>
          </div>
          <img src="/static/imgs/pcmap.png" class="maps" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {

      }
    },
    mounted() {

    },
    metaInfo() {
      return {
        title: '聚木网-关于我们'
      }
    }
  }
</script>
<style scoped>
  @import url('../../static/css/about.css');
</style>



// WEBPACK FOOTER //
// src/components/abous.vue